
export default {
    data() {
        return {
            tap: 1,
            noticeList: [], //站内消息
            active: [],   //活动消息
            loading: true, //加载状态
            pointsList: [], //积分消息
        }
    },
    methods: {
        /** actionType 1/2 可跳转积分商城或我的兑换 */
        isPointsMessageNavigable(item) {
            const actionType = Number(item?.actionType)
            return actionType === 1 || actionType === 2
        },
        /** 积分消息：标记已读；可跳转类型再走路由 */
        handlePointsMessageClick(item) {
            this.markAsRead(item, 6)
            const actionType = Number(item?.actionType)
            if (actionType === 1) {
                this.$router.push({ path: '/xcoins/exchange' })
                return
            }
            if (actionType === 2) {
                this.$router.push({
                    path: '/user/xcoins',
                    query: { page: 1, tab: 'exchange' },
                })
            }
        },
        markAsRead(item, messageIndex) {
            if (Number(item?.is_reader) === 0) {
                const messageInfo = Array.isArray(this.$store.state.messageInfo) ? [...this.$store.state.messageInfo] : []
                if (typeof messageInfo[messageIndex] !== 'undefined') {
                    messageInfo[messageIndex] = Math.max((Number(messageInfo[messageIndex]) || 0) - 1, 0)
                    this.$store.commit('MESSAGEINFO', messageInfo)
                }
                item.is_reader = 1
            }
            // this.$global.updateNotice({ id: item?.id })
        },
        // 活动消息
        async userInfoActivityMessage() {
            let res = await this.$global.userInfoActivityMessage()
            if (res.code == 200) {
                this.active = res.data.noticeList.data
                this.loading = false
                let messageInfo = []
                for (let key in res.data.get_message) {
                    messageInfo.push(res.data.get_message[key])
                }
                this.$store.commit('MESSAGEINFO', messageInfo)
            } else {
                this.$message.error(res.msg);
            }

        },
        // 系统消息
        async userInfoSystemMessage() {
            let res = await this.$global.userInfoSystemMessage()
            if (res.code == 200) {
                this.noticeList = res.data.noticeList.data
                this.loading = false
                let messageInfo = []
                for (let key in res.data.get_message) {
                    messageInfo.push(res.data.get_message[key])
                }
                this.$store.commit('MESSAGEINFO', messageInfo)
            } else {
                this.$message.error(res.msg)
            }

        },
        // 积分消息
        async userInfoPoints() {
            let res = await this.$global.userInfoPoints()
            if (res.code == 200) {
                this.pointsList = res.data.noticeList.data
                this.loading = false
                let messageInfo = []
                for (let key in res.data.get_message) {
                    messageInfo.push(res.data.get_message[key])
                }
                this.$store.commit('MESSAGEINFO', messageInfo)
            } else {
                this.$message.error(res.msg)
            }
        }
    },
    mounted() {
        this.userInfoActivityMessage()
        this.userInfoSystemMessage()
        this.userInfoPoints()
    }
}
